module.exports = __webpack_public_path__ + "static/img/logo_hewego.c47a63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_hewego.png
// module id = 8GfF
// module chunks = 51